import { z } from 'zod';

export enum OrganizationAddressHealthStatus {
  MATCH = 'MATCH',
  MISMATCH = 'MISMATCH',
  UNKNOWN = 'UNKNOWN',
}

export const transactionVisibilityValueSchema = z.enum([
  'all-members',
  'policy-participants',
]);
export type TransactionVisibilityValue = z.infer<
  typeof transactionVisibilityValueSchema
>;

export function getTransactionVisibilityLabel(
  hideTransactionsFromNonPolicyParticipants: boolean
) {
  return hideTransactionsFromNonPolicyParticipants
    ? 'Only admins, initiators, and approvers'
    : 'All organization members';
}

export const hideTransactionsFromNonPolicyParticipantsSchema = z.boolean();

export type OrganizationItemType =
  | 'policies'
  | 'accounts'
  | 'groups'
  | 'members'
  | 'addressBookEntries';

export type ReorderOrganizationItemsRequest = {
  itemType: OrganizationItemType;
  orderedIds: string[];
};

export type ReorderOrganizationItemsResponse = {
  orderedIds: string[];
};
